// extracted by mini-css-extract-plugin
export default {"buildLocator":"R8VWHullztWqRtrUCuPA"};